/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', () => {
  const localizationForms = document.querySelectorAll('.LocalizationForm');
  const preferredLocalizationByLocale = [
    { matcher: locale => locale.startsWith('pl'), country: 'PL', currency: 'PLN' },
    { matcher: locale => locale.startsWith('en'), country: 'DE', currency: 'EUR' },
    { matcher: locale => locale.startsWith('uk') || locale.startsWith('ua'), country: 'UA', currency: 'UAH' }
  ];

  const getPreferredLocalization = localeCode => {
    const normalizedLocale = (localeCode || '').toLowerCase();
    const match = preferredLocalizationByLocale.find(item => item.matcher(normalizedLocale));

    return match || null;
  };

  localizationForms.forEach(form => {
    const countrySelect = form.querySelector('[data-localization-country]');
    const hiddenCountryInput = form.querySelector('[data-localization-country-hidden]');
    const languageSelect = form.querySelector('[data-localization-language]');
    const submitLocalizationForm = () => {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
        return;
      }

      form.submit();
    };

    const syncCountryWithLanguage = localeCode => {
      if (!countrySelect) {
        return;
      }

      const preferredLocalization = getPreferredLocalization(localeCode);

      if (!preferredLocalization) {
        return;
      }

      const countryOptions = Array.from(countrySelect.options);
      const preferredOption =
        countryOptions.find(option => option.value === preferredLocalization.country) ||
        countryOptions.find(option => option.dataset.currencyCode === preferredLocalization.currency);

      if (!preferredOption) {
        return;
      }

      countrySelect.value = preferredOption.value;

      if (hiddenCountryInput) {
        hiddenCountryInput.value = preferredOption.value;
      }
    };

    if (countrySelect) {
      countrySelect.addEventListener('change', () => {
        if (hiddenCountryInput) {
          hiddenCountryInput.value = countrySelect.value;
        }

        submitLocalizationForm();
      });
    }

    if (languageSelect) {
      languageSelect.addEventListener('change', () => {
        syncCountryWithLanguage(languageSelect.value);
        submitLocalizationForm();
      });
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('MenuDrawer');

  if (!drawer) {
    return;
  }

  const submenuTriggers = drawer.querySelectorAll('[data-menu-drawer-open]');
  const submenuPanels = drawer.querySelectorAll('[data-menu-drawer-panel]');
  const backButtons = drawer.querySelectorAll('[data-menu-drawer-back]');
  const drawerDismissButtons = drawer.querySelectorAll('[data-tg-dismiss="Drawer"]');
  const activeSubmenuTitle = drawer.querySelector('[data-menu-drawer-active-title]');
  const submenuHeaders = drawer.querySelectorAll('.MenuDrawer__SubmenuHeader');
  const setActiveSubmenuTitle = title => {
    if (!activeSubmenuTitle) {
      return;
    }

    activeSubmenuTitle.textContent = title || '';
    activeSubmenuTitle.removeAttribute('href');
  };

  const closeSubmenus = () => {
    drawer.classList.remove('MenuDrawer--submenuOpen');
    drawer.removeAttribute('data-menu-drawer-active');
    setActiveSubmenuTitle('');

    submenuPanels.forEach(panel => {
      panel.classList.remove('is-active');
      panel.setAttribute('aria-hidden', 'true');
    });

    submenuTriggers.forEach(trigger => {
      trigger.setAttribute('aria-expanded', 'false');
    });
  };

  const openSubmenu = (targetId, title) => {
    if (!targetId) {
      return;
    }

    const targetPanel = drawer.querySelector(`[data-menu-drawer-panel="${targetId}"]`);

    submenuPanels.forEach(panel => {
      const isTarget = panel.getAttribute('data-menu-drawer-panel') === targetId;
      panel.classList.toggle('is-active', isTarget);
      panel.setAttribute('aria-hidden', (!isTarget).toString());
    });

    submenuTriggers.forEach(trigger => {
      const isActive = trigger.getAttribute('data-menu-drawer-open') === targetId;
      trigger.setAttribute('aria-expanded', isActive.toString());
    });

    drawer.classList.add('MenuDrawer--submenuOpen');
    drawer.setAttribute('data-menu-drawer-active', targetId);
    const targetTitle = title || targetPanel?.getAttribute('data-menu-drawer-title') || '';

    setActiveSubmenuTitle(targetTitle);
  };

  submenuTriggers.forEach(trigger => {
    trigger.addEventListener('click', event => {
      event.preventDefault();
      const targetId = trigger.getAttribute('data-menu-drawer-open');
      const triggerTitle = trigger.textContent?.trim();

      if (targetId) {
        openSubmenu(targetId, triggerTitle);
      }
    });
  });

  backButtons.forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();
      const activePanelId = drawer.getAttribute('data-menu-drawer-active');
      const activePanel = activePanelId
        ? drawer.querySelector(`[data-menu-drawer-panel="${activePanelId}"]`)
        : null;
      const parentTarget = activePanel?.getAttribute('data-menu-drawer-parent');

      if (parentTarget && parentTarget !== 'primary') {
        openSubmenu(parentTarget);
        return;
      }

      closeSubmenus();
    });
  });

  drawer.addEventListener('hidden.tg.Drawer', closeSubmenus);

  drawerDismissButtons.forEach(button => {
    button.addEventListener('click', closeSubmenus);
  });

  submenuHeaders.forEach(header => {
    const toggleButton = header.querySelector('[data-tg-toggle="Collapse"]');

    if (!toggleButton) {
      return;
    }

    header.addEventListener('click', event => {
      const clickedToggle = event.target.closest('[data-tg-toggle="Collapse"]');

      if (clickedToggle) {
        return;
      }

      if (event.target.closest('a')) {
        event.preventDefault();
      }

      toggleButton.click();
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const lists = document.querySelectorAll('.Breadcrumb--product');
  if (!lists.length) return;

  const ellipsis = '...';

  const init = (list) => {
    const lastLi = list.querySelector('.Breadcrumb__Item--product');
    if (!lastLi) return;

    const prevLi = lastLi.previousElementSibling;
    if (!prevLi || !prevLi.classList.contains('Breadcrumb__Item')) return;

    // Zbuduj grupę jako jeden flex-item
    const group = document.createElement('li');
    group.className = 'Breadcrumb__Item Breadcrumb__Group';

    const prevWrap = document.createElement('span');
    prevWrap.className = 'Breadcrumb__GroupPrev';
    prevWrap.innerHTML = prevLi.innerHTML; // zachowuje link

    const productWrap = document.createElement('span');
    productWrap.className = 'Breadcrumb__GroupProduct';

    const productLink = document.createElement('a');
    const productAnchor = lastLi.querySelector('a');
    if (productAnchor) {
      productLink.href = productAnchor.getAttribute('href');
    }
    productWrap.appendChild(productLink);

    // pełny tekst produktu – atrybut wygrywa, potem textContent
    const readFullText = () => {
      const attr = lastLi.getAttribute('data-full-text');
      return (attr && attr.trim()) ? attr.trim() : lastLi.textContent.trim();
    };

    let fullText = readFullText();
    productLink.textContent = fullText;

    group.appendChild(prevWrap);
    group.appendChild(productWrap);

    // Podmień prev+last na grupę
    list.insertBefore(group, prevLi);
    prevLi.remove();
    lastLi.remove();

    let rafId = null;

    const update = () => {
      rafId = null;

      // reset do pełnego tekstu
      productLink.textContent = fullText;

      const listWidth = list.clientWidth;
      if (!listWidth) return;

      // dostępne miejsce w grupie = szerokość listy - (szerokość grupy bez produktu)
      // mierzymy szerokość prevWrap + separatora (w group::before) przez różnicę
      const groupRect = group.getBoundingClientRect();
      const prevRect = prevWrap.getBoundingClientRect();

      // ile zostaje na produkt w obrębie grupy:
      // (cała szerokość wiersza dla grupy) - (prev + separator + paddingi grupy)
      const available = Math.floor(listWidth - (prevRect.width + (groupRect.width - (prevRect.width + productWrap.getBoundingClientRect().width))));
      // uproszczenie stabilne: policz “in place” przez klienta:
      // ustaw maxWidth na produkt jako (group.clientWidth - prevWrap.offsetWidth - odstępy)
      const avail2 = Math.floor(group.clientWidth - prevWrap.offsetWidth - 8); // 8 ~ paddingi/strzałka; zostawiamy margines
      const finalAvail = Math.max(0, isFinite(avail2) ? avail2 : available);

      productWrap.style.maxWidth = `${finalAvail}px`;

      if (finalAvail <= 0) {
        productLink.textContent = ellipsis;
        return;
      }

      if (productWrap.scrollWidth <= productWrap.clientWidth) return;

      let low = 0;
      let high = fullText.length;

      while (low < high) {
        const mid = Math.ceil((low + high) / 2);
        const candidate = fullText.slice(0, mid).trimEnd();
        productLink.textContent = candidate ? candidate + ellipsis : ellipsis;

        if (productWrap.scrollWidth <= productWrap.clientWidth) low = mid;
        else high = mid - 1;
      }

      let finalText = fullText.slice(0, low).trimEnd();
      productLink.textContent = finalText ? finalText + ellipsis : ellipsis;

      while (finalText.length && productWrap.scrollWidth > productWrap.clientWidth) {
        finalText = finalText.slice(0, -1).trimEnd();
        productLink.textContent = finalText ? finalText + ellipsis : ellipsis;
      }
    };

    const scheduleUpdate = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(update);
    };

    // Jeśli ktoś zmienia nazwę produktu w runtime: aktualizuj fullText przez atrybut
    const mo = new MutationObserver(() => {
      const attr = group.getAttribute('data-full-text');
      if (attr && attr.trim() && attr.trim() !== fullText) {
        fullText = attr.trim();
        scheduleUpdate();
      }
    });
    mo.observe(group, { attributes: true, attributeFilter: ['data-full-text'] });

    const ro = new ResizeObserver(scheduleUpdate);
    ro.observe(list);
    ro.observe(group);

    scheduleUpdate();

    if (document.fonts?.ready) {
      document.fonts.ready.then(scheduleUpdate).catch(scheduleUpdate);
    }
    window.addEventListener('resize', scheduleUpdate);
  };

  lists.forEach(init);
});

document.addEventListener('DOMContentLoaded', () => {
  const similarProductsLists = document.querySelectorAll('.SimilarProducts__List');

  similarProductsLists.forEach(list => {
    let isMouseDown = false;
    let startX = 0;
    let scrollLeftStart = 0;
    let didDrag = false;

    const DRAG_THRESHOLD = 8;

    const stopDragging = () => {
      if (!isMouseDown) {
        return;
      }

      isMouseDown = false;
      list.classList.remove('is-dragging');
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };

    const onMouseMove = event => {
      if (!isMouseDown) {
        return;
      }

      const deltaX = event.clientX - startX;

      if (!didDrag && Math.abs(deltaX) < DRAG_THRESHOLD) {
        return;
      }

      didDrag = true;
      event.preventDefault();
      list.scrollLeft = scrollLeftStart - deltaX;
    };

    const onMouseUp = () => {
      stopDragging();

      if (!didDrag) {
        return;
      }

      requestAnimationFrame(() => {
        didDrag = false;
      });
    };

    list.addEventListener('dragstart', event => {
      event.preventDefault();
    });

    list.addEventListener('mousedown', event => {
      if (event.button !== 0) {
        return;
      }

      isMouseDown = true;
      didDrag = false;
      startX = event.clientX;
      scrollLeftStart = list.scrollLeft;
      list.classList.add('is-dragging');

      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
    });

    list.addEventListener('mouseleave', () => {
      if (!isMouseDown) {
        return;
      }

      stopDragging();
    });

    list.addEventListener('click', event => {
      if (!didDrag) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      didDrag = false;
    }, true);
  });
});

/* Der Uebersetzer fuer das Label „Sprawdz cene swojego Rozmiaru“ ist am
   2026-09-10 entfallen. Er lief ueber einen MutationObserver auf dem ganzen
   <body>; im Size-Picker-Modus gibt es dieses Label nicht mehr, und alle
   neuen Texte stehen in locales/*.json unter product.size_picker. */

document.addEventListener('DOMContentLoaded', () => {
  const upsellKitTranslationsByLocale = [
    {
      matcher: locale => locale.startsWith('pl'),
      values: {
        heading: 'R\u00f3wnie\u017c polecamy',
        add: 'Dodaj'
      }
    },
    {
      matcher: locale => locale.startsWith('cs'),
      values: {
        heading: 'Doporu\u010dujeme tak\u00e9',
        add: 'P\u0159idat'
      }
    },
    {
      matcher: locale => locale.startsWith('de'),
      values: {
        heading: 'Wir empfehlen au\u00dferdem',
        add: 'Hinzuf\u00fcgen'
      }
    },
    {
      matcher: locale => locale.startsWith('es'),
      values: {
        heading: 'Tambi\u00e9n recomendamos',
        add: 'A\u00f1adir'
      }
    },
    {
      matcher: locale => locale.startsWith('fr'),
      values: {
        heading: 'Nous recommandons aussi',
        add: 'Ajouter'
      }
    },
    {
      matcher: locale => locale.startsWith('it'),
      values: {
        heading: 'Ti consigliamo anche',
        add: 'Aggiungi'
      }
    },
    {
      matcher: locale => locale.startsWith('en'),
      values: {
        heading: 'We also recommend',
        add: 'Add'
      }
    }
  ];

  const getUpsellKitTranslations = localeCode => {
    const normalizedLocale = (localeCode || '').toLowerCase();
    const match = upsellKitTranslationsByLocale.find(item => item.matcher(normalizedLocale));

    return match ? match.values : upsellKitTranslationsByLocale[upsellKitTranslationsByLocale.length - 1].values;
  };

  const applyUpsellKitTranslations = () => {
    const translations = getUpsellKitTranslations(document.documentElement.lang);

    document.querySelectorAll('.ewck-cu-he-t').forEach(element => {
      if (element.textContent !== translations.heading) {
        element.textContent = translations.heading;
      }
    });

    document.querySelectorAll('.ewck-cu-info-action-atc span').forEach(element => {
      if (element.textContent !== translations.add) {
        element.textContent = translations.add;
      }
    });
  };

  if (!document.body) {
    return;
  }

  let frameId = null;
  const scheduleUpsellKitTranslations = () => {
    if (frameId !== null) {
      cancelAnimationFrame(frameId);
    }

    frameId = requestAnimationFrame(() => {
      frameId = null;
      applyUpsellKitTranslations();
    });
  };

  scheduleUpsellKitTranslations();

  const observer = new MutationObserver(scheduleUpsellKitTranslations);
  observer.observe(document.body, { childList: true, subtree: true });
});
